export function scrollPageToTop(): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.documentElement.scrollTo(0, 0);
}
